var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKazakhstan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4189C24.8366 32.4189 32 25.2555 32 16.4189C32 7.58239 24.8366 0.418945 16 0.418945C7.16344 0.418945 0 7.58239 0 16.4189C0 25.2555 7.16344 32.4189 16 32.4189Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0435 16.5927H6.95654C6.95654 17.8414 8.04411 18.8536 9.29267 18.8536H9.21742C9.21742 20.1022 10.2296 21.1144 11.4783 21.1144C11.4783 22.3631 12.4905 23.3753 13.7392 23.3753H18.2609C19.5096 23.3753 20.5218 22.3631 20.5218 21.1144C21.7705 21.1144 22.7827 20.1022 22.7827 18.8536H22.7074C23.9559 18.8536 25.0435 17.8414 25.0435 16.5927V16.5927Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.261 13.6367C22.261 17.0945 19.4579 19.8976 16.0001 19.8976C12.5423 19.8976 9.73926 17.0945 9.73926 13.6367",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7821 13.6359L18.8281 14.5551L19.8686 16.4476L17.7468 16.0417L17.4779 18.1852L16 16.6086L14.522 18.1852L14.2531 16.0417L12.1313 16.4475L13.1718 14.5551L11.2178 13.6359L13.1718 12.7168L12.1313 10.8244L14.2531 11.2302L14.522 9.08675L16 10.6633L17.478 9.08675L17.7468 11.2302L19.8687 10.8244L18.8281 12.7169L20.7821 13.6359Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKazakhstan);
export default __webpack_public_path__ + "static/media/kazakhstan.06f3ef1b.svg";
export { ForwardRef as ReactComponent };